import { createMuiTheme } from '@material-ui/core/styles';
import { green, grey, red } from '@material-ui/core/colors';

const rawTheme = createMuiTheme({
  palette: {
    primary: {
      light: '#17212B',
      main: '#10151A',
      dark: '#131A22',
    },
    secondary: {
      light: '#2B5278',
      veryLight: '#769097',
      main: 'rgb(42,83,119)',
      dark: 'rgb(42,83,119)',
    },
    warning: {
      main: '#ffc071',
      dark: '#ffb25e',
    },
    error: {
      xLight: red[50],
      main: red[500],
      dark: red[700],
    },
    success: {
      xLight: green[50],
      dark: green[700],
    },
    text: {
      primary: '#F7F7F8',
      secondary: '#ADADAE',
    },
    common: {
      white: '#F7F7F8',
    },
  },
  typography: {
    fontFamily: "'Open Sans', sans-serif",
    fontSize: 14,
    fontWeightLight: 300, // Work Sans
    fontWeightRegular: 400, // Work Sans
    fontWeightMedium: 700, // Roboto Condensed
    fontFamilySecondary: "'Open Sans', sans-serif",
  },
  overrides: {
    MuiContainer: {
      maxWidthXl: {
        maxWidth: '1300px !important',
      },
    },
    MuiPaper: {
      '@global': {
        '*': {
          'scrollbar-width': 20,
        },
        '*::webkit-scrollbar': {
          width: 4,
          height: 4,
        },
      },
      root: {
        backgroundColor: '#17212B',
        color: '#F7F7F8',
      },
    },
    MUIDataTableBodyCell: {
      root: {
        backgroundColor: '#131A22',
      },
    },
    MuiTableRow: {
      root: {
        backgroundColor: '#131A22',
      },
    },
    MuiTable: {
      root: {
        backgroundColor: '#131A22',
      },
    },
    MUIDataTableToolbar: {
      root: {
        backgroundColor: '#131A22',
      },
    },
    MuiTableCell: {
      root: {
        borderBottom: '2px solid rgb(32, 43, 57)',
      },
    },
    MUIDataTableHeadCell: {
      fixedHeader: {
        backgroundColor: '#131A22',
      },
    },
    MUIDataTableSelectCell: {
      headerCell: {
        backgroundColor: '#131A22',
      },
    },
    MuiPickersCalendarHeader: {
      dayLabel: {
        color: '#F7F7F8',
      },
    },
    MuiButton: {
      textPrimary: {
        color: '#F7F7F8',
      },
    },
  },
  props: {
    MuiContainer: {
      maxWidth: 'xl',
    },
  },
});

const fontHeader = {
  color: rawTheme.palette.text.primary,
  fontWeight: rawTheme.typography.fontWeightMedium,
  fontFamily: rawTheme.typography.fontFamilySecondary,
  textTransform: 'uppercase',
};

const theme = {
  ...rawTheme,
  palette: {
    ...rawTheme.palette,
    background: {
      ...rawTheme.palette.background,
      default: rawTheme.palette.primary.main,
      placeholder: grey[200],
    },
  },
  typography: {
    ...rawTheme.typography,
    fontHeader,
    h1: {
      ...rawTheme.typography.h1,
      ...fontHeader,
      letterSpacing: 0,
      fontSize: 60,
    },
    h2: {
      ...rawTheme.typography.h2,
      ...fontHeader,
      fontSize: 48,
    },
    h3: {
      ...rawTheme.typography.h3,
      ...fontHeader,
      fontSize: 42,
    },
    h4: {
      ...rawTheme.typography.h4,
      ...fontHeader,
      fontSize: 36,
    },
    h5: {
      ...rawTheme.typography.h5,
      fontSize: 14,
      fontWeight: rawTheme.typography.fontWeightLight,
    },
    h6: {
      ...rawTheme.typography.h6,
      ...fontHeader,
      fontSize: 18,
    },
    subtitle1: {
      ...rawTheme.typography.subtitle1,
      fontSize: 18,
    },
    body1: {
      ...rawTheme.typography.body2,
      fontWeight: rawTheme.typography.fontWeightRegular,
      fontSize: 14,
    },
    body2: {
      ...rawTheme.typography.body1,
      fontSize: 14,
    },
  },
};

export default theme;
